import React from 'react';
interface CTAButtonProps {
  children?: React.ReactNode;
  className?: string;
  href?: string;
}
export function CTAButton({
  children = 'Jetzt das Musik-Paket sichern',
  className = '',
  href = '#checkout'
}: CTAButtonProps) {
  return <a href={href} className={`inline-flex w-full items-center justify-center gap-3 rounded-full bg-brand-orange px-8 py-4 text-xs font-extrabold uppercase tracking-[0.12em] text-white shadow-md transition-colors duration-200 ease-out hover:bg-[#d1521e] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange focus-visible:ring-offset-2 sm:w-auto sm:text-sm ${className}`} data-id="element-38" data-mp="2kzzi4vr3lkvf">
      <span data-id="element-39" data-mp="33r0fjfckl8cv">{children}</span>
      <span aria-hidden="true" className="text-base leading-none" data-id="element-40" data-mp="2ypjftn5tnrxv">
        →
      </span>
    </a>;
}